import React, { useEffect } from "react";

const AwsRegister = () => {
  useEffect(() => {
    console.log("🔍 Current URL:", window.location.href);

    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token") || localStorage.getItem("awsMarketplaceToken");


    console.log("🧪 Extracted token:", token || "[Missing]");

    if (!token) {
      alert("Missing AWS Marketplace token.");
      return;
    }

    console.log("✅ Token found. Verifying with backend...");

    // Call your backend to validate the token
    fetch(`https://8vjkpc6wy0.execute-api.ap-southeast-2.amazonaws.com/prod/api/resolve-token?token=${token}`)
      .then((res) => {
        console.log("📡 Backend response status:", res.status);
        return res.json();
      })
      .then((data) => {
        console.log("📥 Backend response data:", data);

        if (data.customerIdentifier) {
          console.log("✅ Customer identifier received:", data.customerIdentifier);

          // Save the customer ID temporarily
          sessionStorage.setItem("awsCustomerId", data.customerIdentifier);

          // Redirect to Cognito Hosted UI for login
          window.location.href = `https://unicorn.srvql.com`;
        } else {
          alert("Invalid token.");
        }
      })
      .catch((err) => {
        console.error("❌ Error verifying token:", err);
        alert("Error verifying subscription.");
      });
  }, []);

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
      <div>
        <h2>Verifying AWS Marketplace Subscription...</h2>
      </div>
    </div>
  );
};

export default AwsRegister;
